
import { Action } from '@ngrx/store';

import * as RegsDetailsActions from './../actions/registration-details.actions';
import { RegistrationDetails } from 'src/app/model/ngrx/registration-details.model';

export type Actions = RegsDetailsActions.Actions;

const initialState: RegistrationDetails = {
    userTitle:'',
    otherTitle:'',
    forename: '',
    surname: '',
    middleName: '',
    thirdName:'',
    dateOfBirth: '',
    emailAddress: '',
    confirmEmailAddress:'',
    maritalStatus: '',
    gender: '',
    postcode: '',
    ukaddressIndicator: '',
    addressline1: '',
    addressline2:'',
    addressline3: '',
    addressline4: '',
    homePhone: '',
    mobilePhone:'',
    internalSoftOptInInd: null
};

export function regsDetailsReducer(state: RegistrationDetails[] = [initialState], action: RegsDetailsActions.Actions) {
    switch (action.type) {
        case RegsDetailsActions.ADD_REGISTRATION_DETAILS:
            return [...state, action.payload];

        // Add this case:
        case RegsDetailsActions.REMOVE_REGISTRATION_DETAILS:
            state = [];
            return state;
        default:
            return state;
    }
}
